/* This example requires Tailwind CSS v2.0+ */
import { CheckIcon } from '@heroicons/react/outline'

const features = [
  { name: 'Comprehensive Exams', description: '', },
  { name: 'Cleaning', description: '' },
  { name: 'Restorative Dentistry', description: '', },
  { name: 'Cosmetic Dentistry', description: '' },
  { name: 'Same-Day Crowns', description: '' },
  { name: 'Tooth Extractions', description: '' },
  { name: 'Teeth Whitening', description: '' },
  { name: 'INVISALIGN/Suresmile Clear Aligner', description: '' },
  { name: 'Dentures/Partials', description: '' },
  { name: 'Adult/Infant Laser Tongue-Tie Surgery', description: '' },
  { name: 'Implants', description: '' },
  { name: 'Emergency Services', description: '' },
]

export default function Example() {
  return (
    <div className="bg-gray-50" id="our-services">
      <div className="max-w-7xl mx-auto py-6 px-6 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8">
        <div>
          <p className="pt-4 pb-8 text-3xl tracking-tight font-bold text-gray-900">Our Services</p>
        </div>
        <div className="mt-0 lg:col-span-3">
          <dl className="space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-4 sm:grid-flow-col sm:gap-x-4 sm:gap-y-6 lg:gap-x-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <CheckIcon className="absolute h-6 w-6 text-green-500" aria-hidden="true" />
                  <p className="ml-9 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                </dt>
                {/* <dd className="mt-2 ml-9 text-base text-gray-500">{feature.description}</dd> */}
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
